import type { FunctionComponent, ReactElement } from 'react';
import { useIsSBOMPolicyEnabled } from '../../../helpers/features';

type SBOMRequiredProps = {
  children: ReactElement<any, any> | null;
};

/**
 * Access gate which renders any children, but only if 'SBOM Policy' is enabled for the org.
 *
 * @example - Button only renders if 'SBOM Policy' is enabled:
 * <SBOMRequired>
 *   <Button>Download SBOM Report</Button>
 * </SBOMRequired>
 */
const SBOMRequired: FunctionComponent<SBOMRequiredProps> = ({ children }) => {
  const hasSBOM = useIsSBOMPolicyEnabled();

  if (!hasSBOM) {
    return null;
  }

  return children;
};

export default SBOMRequired;
